import { getRouteEventDetails } from '@shared/constants/router';
import { formatDate } from '@shared/libs/format-date';
import styles from './event-list-item.module.scss';
import { SminexIcon } from '@shared/assets/icons';
import { SminexClubGroup } from '@features/auth';
import { useNavigate } from 'react-router-dom';
import { isEventInGroup } from '@shared/lib';
import { forwardRef, useState } from 'react';
import { Event } from '@entities/event';
import clsx from 'clsx';

interface EventListItemProps {
  event: Event;
  groupName?: string | null;
}

const formatNumber = (number: number) => new Intl.NumberFormat('ru-RU').format(number);

export const EventListItem = forwardRef<HTMLDivElement, EventListItemProps>(({ event, groupName }, ref) => {
  const { image, dateStart, name, active, ticketsMetadata, metadata } = event;
  const { total, checkedCount } = ticketsMetadata;
  const { countAcceptedInvites } = metadata;
  const [imageError, setImageError] = useState(false);
  const navigate = useNavigate();

  const isSminexClubGroup = isEventInGroup(event.groups, SminexClubGroup, groupName ?? null);
  const percentAccepted = Math.round((countAcceptedInvites * 100) / total) | 0;
  const widthAccepted = `${(checkedCount / total) * 100}%`;
  const percentChecked = Math.round((checkedCount * 100) / total) | 0;
  const widthChecked = `${(checkedCount / total) * 100}%`;

  const handleNavigate = () => {
    navigate(getRouteEventDetails(`${event.id}`));
  };

  return (
    <div className={styles.event} onClick={handleNavigate} ref={ref}>
      <div className={styles.header}>
        <div className={styles.icon}>
          {image && !imageError ? <img src={image} alt={name} onError={() => setImageError(true)} /> : <SminexIcon />}
        </div>

        <div className={styles.title}>{name}</div>
      </div>

      {ticketsMetadata && Object.keys(ticketsMetadata).length > 0 && (
        <div className={styles.container}>
          <div className={styles.statisticText}>
            {isSminexClubGroup ? (
              <>
                <p>Приглашено:</p>
                <p>Подтвержденные:</p>
              </>
            ) : (
              <>
                <p>
                  Приглашено <span>/ 100%</span>
                </p>
                <p>
                  Принято <span>/ {percentAccepted}%</span>
                </p>
                <p>
                  Зарегистрировано <span>/ {percentChecked}%</span>
                </p>
              </>
            )}
          </div>

          <div className={styles.statistic}>
            <span className={styles.total}>{formatNumber(total)}</span>

            {!isSminexClubGroup && (
              <span className={styles.countAccepted} style={{ width: widthAccepted }}>
                {formatNumber(countAcceptedInvites)}
              </span>
            )}

            <span className={styles.countChecked} style={{ width: widthChecked }}>
              {formatNumber(checkedCount)}
            </span>
          </div>
        </div>
      )}

      <div className={styles.divider} />

      <div className={styles.footer}>
        {!isSminexClubGroup && (
          <div className={styles.switcher}>
            <p className={clsx(styles.switcherLabel, active && styles.switcherLabelActive)}>
              {active ? 'Активно' : 'Завершено'}
            </p>
          </div>
        )}

        <div className={styles.date}>{formatDate(dateStart)}</div>
      </div>
    </div>
  );
});
